var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgParkingFilled = function SvgParkingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.367 8.292c.083.108.125.266.125.475 0 .225-.05.391-.142.508a.873.873 0 0 1-.367.275c-.158.067-.325.1-.508.117-.192.016-.375.016-.558.016h-.675V7.858h.816c.167 0 .334.009.509.034.175.016.325.058.466.125a.87.87 0 0 1 .325.275h.009ZM18.75 10c0 4.825-3.925 8.75-8.75 8.75S1.25 14.825 1.25 10 5.175 1.25 10 1.25s8.75 3.925 8.75 8.75Zm-5.775-1.258c0-.4-.075-.75-.225-1.025-.15-.275-.35-.5-.6-.659a2.595 2.595 0 0 0-.867-.35 4.964 4.964 0 0 0-1-.1H7.817v7.25h1.425v-2.933h.816c.375 0 .742-.025 1.092-.083.35-.05.667-.159.933-.317.275-.158.492-.383.65-.667.167-.291.242-.666.242-1.116Z",
    fill: "current"
  })));
};
export default SvgParkingFilled;